<!-- @format -->

<section *ngIf="data">
	<div class="fullStoryV2 position-relative">
		<div class="image-box">
			<a
				class="fullStory__link"
				[href]="story.link"
				[attr.data-em]="createTag(1, 0, '', story.headline)"
				[target]="
					story.link.indexOf('://') > 0 || story.link.indexOf('//') === 0
						? '_blank'
						: '_self'
				">
				<shared-media-component-media
					*ngIf="story.image || story.visualAssets"
					[visualAssets]="story.visualAssets"
					[altText]="story.altText"
					[image]="story.image"
					[mobileImg]="story.mobileImg"
					[itemTitle]="story.headline ? story.headline : story.description"
					[animation]="story.animation"
					[willLazyLoad]="willLazyLoad">
				</shared-media-component-media>
			</a>
		</div>
		<div
			class="fullStory__copy copy-block"
			[sharedUtilsDirectiveAppNoBackground]="story.textBlockBackground"
			[textColor]="story.textColor"
			[ngClass]="{
				'text-box-left': story.textBoxPosition === 'left',
				'text-box-center': story.textBoxPosition === 'center',
				'text-box-right': story.textBoxPosition === 'right'
			}">
			<div>
				<clp-mwc-badge
					[data]="story.badge && story.badge.length"
					*ngIf="story.badge"></clp-mwc-badge>
			</div>
			<p
				class="text text--headline pt-4"
				[ngClass]="{ 'no-badge': story.badge === 'none' }">
				{{ story.headline }}
			</p>
			<p class="text text--subtext">
				{{ story.description }}
				<a
					*ngIf="story.optionalDetailsLink"
					class="text text--subtext details-link"
					[href]="story.optionalDetailsLink"
					>Details</a
				>
			</p>

			<div class="fullStory__ctas mt-3">
				<clp-cta
					*ngFor="let cta of story.cta; let j = index; trackBy: trackByCta"
					[data]="cta"
					[altText]="story.headline"
					[tagSectionNum]="tagSectionNum"
					[widgetTypeTag]="widgetTypeTag"
					[ctaIndex]="j + 1"
					[parentIndex]="1"
					[ctaType]="story.badge"
					[chevron]="true">
				</clp-cta>
			</div>
		</div>
	</div>
</section>
